import { render } from "./PpcSbBudgetAllocation.vue?vue&type=template&id=7c0f9a1e&scoped=true"
import script from "./PpcSbBudgetAllocation.vue?vue&type=script&lang=js"
export * from "./PpcSbBudgetAllocation.vue?vue&type=script&lang=js"

import "./PpcSbBudgetAllocation.vue?vue&type=style&index=0&id=7c0f9a1e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c0f9a1e"]])

export default __exports__